import { p, strong, hr, wrapHTML, parseMarkdown } from './htmlUtils';

/**
 * Format Newsletter data as HTML (matches NewsletterRenderer.tsx)
 */
export const formatNewsletterHTML = (data: any): string => {
  if (!data || !data.subject_line) {
    return wrapHTML(p('No newsletter content available'));
  }

  const sections: string[] = [];

  // Subject Line
  sections.push(p(`${strong('Subject:')} ${data.subject_line}`));

  // Preheader (optional)
  if (data.preheader) {
    sections.push(p(`${strong('Preheader:')} ${data.preheader}`));
  }

  // Greeting
  if (data.greeting) {
    sections.push(p(parseMarkdown(data.greeting).replace(/\n/g, '<br/>')));
  }

  // Main Content
  if (data.main_content) {
    sections.push(p(parseMarkdown(data.main_content).replace(/\n/g, '<br/>')));
  }

  // CTA
  if (data.cta) {
    sections.push(p(strong(parseMarkdown(data.cta).replace(/\n/g, '<br/>'))));
  }

  // Secondary Content (optional)
  if (data.secondary_content) {
    sections.push(p(parseMarkdown(data.secondary_content).replace(/\n/g, '<br/>')));
  }

  // Closing
  if (data.closing) {
    sections.push(p(parseMarkdown(data.closing).replace(/\n/g, '<br/>')));
  }

  // Footer separator
  sections.push(hr());

  // Footer
  if (data.footer) {
    sections.push(p(parseMarkdown(data.footer).replace(/\n/g, '<br/>')));
  }

  return wrapHTML(sections.join(''));
};

